'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SchoolCamps = function (_Component) {
  (0, _inherits3.default)(SchoolCamps, _Component);

  function SchoolCamps() {
    (0, _classCallCheck3.default)(this, SchoolCamps);
    return (0, _possibleConstructorReturn3.default)(this, (SchoolCamps.__proto__ || (0, _getPrototypeOf2.default)(SchoolCamps)).apply(this, arguments));
  }

  (0, _createClass3.default)(SchoolCamps, [{
    key: 'render',
    value: function render() {
      var styles = require('./SchoolCamps.scss');
      var photoIntro = require('./camps-intro.jpg');
      var photo1 = require('./camps1.jpg');
      var photo2 = require('./camps2.jpg');
      var photo3 = require('./camps3.jpg');

      var data = {
        intro: {
          text: 'Pro školy organizujeme pobyty se zaměřením na všestrannou sportovní přípravu. Sportujeme tak, aby se bavili začátečníci i pokročilí.',
          image: {
            src: photoIntro,
            alt: 'Školní pobyty'
          }
        },
        photos: {
          heading: 'Fotky ze školních pobytů',
          photo1: {
            src: photo1,
            alt: 'Dětské školní pobyty'
          },
          photo2: {
            src: photo2,
            alt: 'Zimní školní pobyty'
          },
          photo3: {
            src: photo3,
            alt: 'Školní pobyty'
          }
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: '\u0160koln\xED pobyty, na kter\xFDch se d\u011Bti bav\xED',
          meta: [{
            name: 'description',
            content: 'Školní pobyty s ubytování v krásném hotelu na horách.'
          }, {
            property: 'og:description',
            content: 'Školní pobyty s ubytování v krásném hotelu na horách.'
          }, {
            property: 'og:title',
            content: 'Školní pobyty, na kterých se děti baví'
          }, {
            name: 'keywords',
            content: 'školní pobyt, školní pobyty'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/skolni-pobyty' }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            '\u0160koln\xED pobyty, ',
            _react2.default.createElement(
              'small',
              null,
              'na kter\xFDch se d\u011Bti bav\xED'
            )
          )
        ),
        _Content2.default.renderIntro(styles, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _Content2.default.renderPhotos(styles, data.photos),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Ubytov\xE1n\xED'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ve velmi p\u011Bkn\xFDch hotelech, nap\u0159\xEDklad ',
                _react2.default.createElement(
                  'a',
                  { href: 'http://www.hotel-rohanov.cz', target: '_blank' },
                  'hotel Rohanov'
                ),
                ', ve dvou a\u017E \u010Dty\u0159 l\u016F\u017Ekov\xFDch pokoj\xEDch. Pokoje jsou modern\u011B vybaven\xE9 a maj\xED vlastn\xED soci\xE1ln\xED za\u0159\xEDzen\xED.'
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Stravov\xE1n\xED \u2013 Pln\xE1 penze'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Sn\xEDdan\u011B jsou formou \u0161v\xE9dsk\xFDch stol\u016F, ob\u011Bd a ve\u010De\u0159e \u2013 pol\xE9vka a tepl\xE9 j\xEDdlo. Po cel\xFD den maj\xED d\u011Bti k dispozici n\xE1poje a sva\u010Dinky.'
              ),
              _react2.default.createElement(
                'h2',
                null,
                'N\xE1pl\u0148'
              ),
              _react2.default.createElement(
                'p',
                null,
                '\u0160kola v p\u0159\xEDrod\u011B je zam\u011B\u0159ena na v\u0161estrannou sportovn\xED p\u0159\xEDpravu. Program prob\xEDh\xE1 na v\xEDce\xFA\u010Delov\xE9m h\u0159i\u0161ti, kter\xE9 je sou\u010D\xE1st\xED komplexu, nebo na p\u0159\xEDrodn\xEDch cest\xE1ch a nedalek\xFDch louk\xE1ch. Cel\xFD program je veden z\xE1bavnou formou, p\u0159i kter\xE9 d\u011Bti rozv\xEDj\xED v\u0161echny z\xE1kladn\xED dovednosti.'
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Prostory k vyu\u017Eit\xED'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Pro v\xFDuku jsou k dispozici dv\u011B velk\xE9 m\xEDstnosti pro 30 d\u011Bt\xED. Na odpoledn\xED program je k dispozici v\xEDce\xFA\u010Delov\xE9 h\u0159i\u0161t\u011B, koupali\u0161t\u011B (cca 500m od komplexu), louky a p\u0159\xEDrodn\xED cesty.'
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Doprava'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Doprava je zaji\u0161t\u011Bna autobusem, kter\xFD bude p\u0159istaven p\u0159\xEDmo ke \u0161kole a d\u011Bti odveze do hotelu Rohanov. Cesta trv\xE1 dv\u011B hodiny.'
              ),
              _react2.default.createElement(
                'h2',
                null,
                'Cena'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Cena \u0161koly v p\u0159\xEDrod\u011B je 3 400 K\u010D na d\xEDt\u011B. V cen\u011B je zahrnuto ubytov\xE1n\xED na 5-6 dn\xED s plnou penz\xED v hotelu Rohanov, doprava autobusem a odpoledn\xED program zaji\u0161t\u011Bn\xFD na\u0161imi tren\xE9ry.'
              ),
              _react2.default.createElement(
                'h2',
                null,
                'M\xE1m z\xE1jem'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Pokud m\xE1te z\xE1jem, nev\xE1hejte se obr\xE1tit na Tom\xE1\u0161e Krupku na telefonn\xED \u010D\xEDslo 725 085 420 nebo napi\u0161te na tomas.krupka@nenudimse.cz'
              )
            )
          )
        )
      );
    }
  }]);
  return SchoolCamps;
}(_react.Component);

exports.default = SchoolCamps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SchoolCamps/SchoolCamps.js
// module id = 1113
// module chunks = 0